import React, { Component } from "react";
import $ from "jquery";
import auth, { _log, get, switchServer } from "../js/auth";
import { Dropdown, Form } from "react-bootstrap";
import DropdownToggle from "react-bootstrap/DropdownToggle";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { I18n } from "react-redux-i18n";
import { getMyStatus, hasRole } from "../js/admin";
import moment from "moment";
import CanAccess from "./CanAccess";

if (typeof localStorage.restaurantNameSelected == "undefined") {
  localStorage.restaurantNameSelected = "Please select a restaurant to administer";
}

//<img alt="" style={{ height: "24px", width: "24px" }} src={auth.globalserver + "/eatwithme.server/adminService/" + restaurant.globalId + "/getRestaurantImage"} />

class RestaurantSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: "",
      isDropdownOpen: false
    };
    this.searchInputRef = React.createRef();
  }

  handleSearchChange = (e) => {
    const newSearchTerm = e.target.value;
    this.setState({ searchTerm: newSearchTerm });

    // Check if there's only one filtered restaurant
    setTimeout(() => {
      const filteredRestaurants = this.filterRestaurants(
        this.props.restaurants.filter(restaurant => restaurant.isActive)
          .sort((a, b) => a.name.localeCompare(b.name))
          .sort((a, b) => (a.test ? 1 : 0) - (b.test ? 1 : 0))
      );

      if (filteredRestaurants.length === 1 && newSearchTerm.length > 2) {
        const restaurant = filteredRestaurants[0];
        this.pickRestaurant(
          restaurant.globalId,
          restaurant.name,
          restaurant.languages,
          restaurant.serverUrl,
          restaurant.backupUrl,
          restaurant.instance
        );
      }
    }, 500); // Debounce to avoid rapid selections
  }

  handleDropdownToggle = (isOpen) => {
    this.setState({
      isDropdownOpen: isOpen,
      searchTerm: isOpen ? this.state.searchTerm : ""
    });

    // Focus the search input when dropdown opens
    if (isOpen) {
      setTimeout(() => {
        if (this.searchInputRef.current) {
          this.searchInputRef.current.focus();
        }
      }, 100);
    }
  }

  handleKeyDown = (e) => {
    e.stopPropagation();

    // Handle Enter key
    if (e.key === 'Enter') {
      const filteredRestaurants = this.filterRestaurants(
        this.props.restaurants.filter(restaurant => restaurant.isActive)
          .sort((a, b) => a.name.localeCompare(b.name))
          .sort((a, b) => (a.test ? 1 : 0) - (b.test ? 1 : 0))
      );

      if (filteredRestaurants.length === 1) {
        const restaurant = filteredRestaurants[0];
        this.pickRestaurant(
          restaurant.globalId,
          restaurant.name,
          restaurant.languages,
          restaurant.serverUrl,
          restaurant.backupUrl,
          restaurant.instance
        );
      }
    }
  }

  filterRestaurants = (restaurants) => {
    if (!this.state.searchTerm) {
      return restaurants;
    }
    const searchLower = this.state.searchTerm.toLowerCase();
    return restaurants.filter(restaurant =>
      restaurant.name.toLowerCase().includes(searchLower) ||
      restaurant.globalId.toString().includes(searchLower)
    );
  }

  render() {
    const { restaurants } = this.props;
    const selectedRestaurantName = this.props.myStatus && this.props.myStatus.restaurant_name
      ? this.props.myStatus.restaurant_name
      : I18n.t("admin_local.please_select_a_restaurant");

    const getRestaurant2 = (restaurant) => {
      if (!restaurant.instance) restaurant.instance = "eatwithme";
      const ntaknotok = !restaurant.test && restaurant?.ntakstatus?.enabled && moment(restaurant?.ntakstatus?.startdate).isBefore(moment()) && restaurant?.ntakstatus?.status && Object.keys(restaurant?.ntakstatus?.status).filter(key => !restaurant?.ntakstatus?.status[key]).length;
      return <Dropdown.Item
        style={{ color: "#857D6D", fontSize: "20px", paddingRight: hasRole(["superadmin"]) ? "3rem" : "0", paddingLeft: hasRole(["superadmin"]) ? "0rem" : "0", backgroundColor: ntaknotok ? "yellow" : restaurant.subscription || restaurant.test ? "" : "blue" }}
        key={restaurant.globalId}
        onClick={() => {
          this.pickRestaurant(restaurant.globalId, restaurant.name, restaurant.languages, restaurant.serverUrl, restaurant.backupUrl, restaurant.instance);
        }}
        className={"dropdown-item " + (restaurant.test ? "test" : "")}
      >
        {(restaurant.test ? "Test - " : "") + restaurant.name}
        {restaurant.subscription && hasRole(["superadmin"]) ? (<div style={{ position: "absolute", fontSize: "10px", right: "0", bottom: "0" }}>{restaurant.subscription}</div>) : null}
        {(!hasRole(["superadmin"]) || !ntaknotok) ? null : <div className="icon-attention" style={{ position: "absolute", fontSize: "8px", right: "0", top: "0", "color": "red" }}>NTAK</div>}
      </Dropdown.Item>
    }

    const filteredRestaurants = this.filterRestaurants(
      restaurants.filter(restaurant => restaurant.isActive)
        .sort((a, b) => a.name.localeCompare(b.name))
        .sort((a, b) => (a.test ? 1 : 0) - (b.test ? 1 : 0))
    );

    var podUrl = auth.server.split("/");

    return (
      <React.Fragment>
        <Dropdown
          key={this.props.restaurantSelected}
          style={{ fontFamily: "var(--font-family)" }}
          onToggle={this.handleDropdownToggle}
          show={this.state.isDropdownOpen}
        >
          <DropdownToggle className="nocaret" variant="none" id="dropdownRestaurantButton">
            <span className="restaurant-name">
              {selectedRestaurantName}
            </span>
            <CanAccess resource="superAdminMenus/">
              <span className="pod" onClick={(event) => { event.stopPropagation(); window.open("https://restaurant.eatwithme.online:30001/#/search?namespace=default&q=" + podUrl[podUrl.length - 1] + "-eatwithme-server"); }}>{podUrl[podUrl.length - 1]}</span>
              <span className="instance">{this.props.myStatus.instance}</span>
              <span className="subscription">{this.props.myStatus.subscription}</span>
            </CanAccess>
          </DropdownToggle>
          {!this.props.disableDropdown && (
          <Dropdown.Menu style={{ maxHeight: "85vh", overflowY: "auto", minWidth: "300px" }}>
            <div style={{ padding: "8px 16px", width: "100%" }}>
              <Form.Control
                ref={this.searchInputRef}
                type="text"
                placeholder={I18n.t("admin_local.search_restaurants")}
                value={this.state.searchTerm}
                onChange={this.handleSearchChange}
                onClick={(e) => e.stopPropagation()}
                onKeyDown={this.handleKeyDown}
                style={{ fontSize: "14px" }}
              />
            </div>
            <Dropdown.Divider />
            {filteredRestaurants.map(restaurant => (
              getRestaurant2(restaurant)
            ))}
            {filteredRestaurants.length === 0 && this.state.searchTerm && (
              <div style={{ padding: "8px 16px", color: "#666", fontStyle: "italic" }}>
                {I18n.t("admin_local.no_restaurants_found")}
              </div>
            )}
          </Dropdown.Menu>
          )}
        </Dropdown>
      </React.Fragment >
    );
  }

  pickRestaurant(restaurantId, name, languages, url, backupUrl, instance) {
    const t = this;
    this.setState({ isDropdownOpen: false, searchTerm: "" }); // Close dropdown and clear search
    switchServer({ globalId: restaurantId, serverUrl: url, backupUrl: backupUrl, name: name, instance: instance }).done(() => {
      getMyStatus(() => {
        // eslint-disable-next-line no-restricted-globals
        if (window.device.platform === "browser" && Number(location.port) !== 3000 && location.href.indexOf("https://hotbackup.eatwithme.online") === -1) {

          get("login/setRestaurant/" + localStorage.restaurantSelected).done(() => {
            t.props.onReload();
          });
        } else {
          //localStorage.server = auth.server;
          get("login/setRestaurant/" + localStorage.restaurantSelected)
            .done(() => {
              // eslint-disable-next-line no-restricted-globals
              t.props.onReload();
            })
            .fail(() => {
              auth.ajaxError = false;
              _log("LOGIN: Failed to set restaurant, reloading to login");
              setTimeout(() => {
                // eslint-disable-next-line no-restricted-globals
                location.reload();
              }, 1000);
            });
        }
      });
    });
  }

  refreshRestaurantHeader() {
    $("#dropdownRestaurantButton").html(localStorage.restaurantNameSelected + "<span class='caret'></span>");
  }
}

const mapStateToProps = state => {
  return {
    restaurants: state.rootReducer.restaurants ? state.rootReducer.restaurants : [],
    restaurantSelected: state.rootReducer.restaurantSelected,
  };
};

export default withRouter(connect(mapStateToProps)(RestaurantSelector));
